module.exports = __webpack_public_path__ + "img/h3.56119e99.png";